import * as Api from '@ViewModels';
import * as React from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { IEditAutomationTemplateRequest, ILocationState } from '../../../models';
import { EditAutomationTemplateStepsContext, IEditAutomationTemplateStepsContext } from '../../../models/Automations';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { isCanvasOnlyAutomationTemplate } from '../../../models/utils/automationTemplateEditorUtils';
import { useAutomationTemplateQuery } from '../../../queries/Automation';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../components-v2/Drawer/AppDrawer';
import { EditAutomationTemplate } from '../../containers/EditAutomationTemplate';
import { DefaultUniversalAssistantChat } from '../../containers/templates/AssistantChat';

export const EditAutomationTemplateWithAppDrawer = () => {
	const userSession = useUserSession();
	const history = useHistory();
	const location = useLocation<ILocationState<Api.IAutomationTemplate, IEditAutomationTemplateRequest>>();
	const params = useParams<{ id: string }>();

	const automationTemplateId = location?.state?.model?.automationTemplate?.id || params.id;
	const routeAutomationTemplate = location?.state?.model?.automationTemplate;
	const { data: fetchedAutomationTemplate } = useAutomationTemplateQuery({
		id: automationTemplateId || '',
		enabled: !!automationTemplateId && !routeAutomationTemplate,
	});
	const automationTemplate = routeAutomationTemplate || fetchedAutomationTemplate;

	React.useEffect(() => {
		if (automationTemplateId && isCanvasOnlyAutomationTemplate(automationTemplate)) {
			history.replace(`/automations/${automationTemplateId}/canvas`);
		}
	}, [automationTemplate, automationTemplateId, history]);

	const [unsavedStep, setUnsavedStep] = React.useState<Api.IAutomationStep>(null);

	const editAutomationTemplateStepsContext = React.useMemo<IEditAutomationTemplateStepsContext>(() => {
		return {
			automationTemplateId,
			impersonationContext: userSession.impersonationContext,
			unsavedStep,
			setUnsavedStep,
		};
	}, [automationTemplateId, userSession.impersonationContext, unsavedStep, setUnsavedStep]);

	return (
		<>
			<EditAutomationTemplateStepsContext.Provider value={editAutomationTemplateStepsContext}>
				<EditAutomationTemplate
					automationTemplateId={location?.state?.model?.automationTemplate?.id}
					onAutomationDeleted={() => history.replace('/automations')}
					onAutomationPublished={() => history.push('/automations')}
					onAutomationDisabled={() => history.push('/automations')}
				/>
				<AppDrawer>
					<StickyAppDrawerContent value='ai-assistant'>
						<DefaultUniversalAssistantChat />
					</StickyAppDrawerContent>
					<AppDrawerToolbar>
						<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
					</AppDrawerToolbar>
				</AppDrawer>
			</EditAutomationTemplateStepsContext.Provider>
		</>
	);
};
